<template>
	<div class="page">
		下载列表
	</div>
</template>

<style scoped="scoped">

</style>

<script>
	export default {
		name: 'Download',
		components: {},
		data() {
			return {}
		},
		created() {
			
		}
	}
</script>
